import { useMemo, useCallback, useState } from 'react';
import sort from 'ramda/es/sort';

import { type OrgsSchools } from 'app/dataProviders/org/OrgsDataProvider';


/**
 *  Управление ids организаций куда копировать и default value
 */

type SortFunc = <T extends { title: string }>(list: ReadonlyArray<T>) => T[]

const defaultSelection = [];

type Options = {
  orgId?: number,
}

type SelectorProps = {
  // items: ActualOrgs,
  selection: Array<string>,
  defaultSelection: Array<string>,
  onChange?: (values: Array<string>) => void,
  sortFunc?: SortFunc
}

export default function useOrgsSelector(orgsState: OrgsSchools, options: Options): [SelectorProps] {

  const [orgIdFrom, setOrgIdFrom] = useState<Array<string>>(defaultSelection);
  const handleChangeOrg = useCallback((values: Array<string>) => {
    setOrgIdFrom(values);
  }, [setOrgIdFrom]);

  const sortByTitle = useCallback<SortFunc>(
    (list) => sort((a, b) => a.title.localeCompare(b.title), list as any),
    []
  )

  const selectorProps = useMemo<SelectorProps>(
    () => ({
      // items: orgs,
      selection: orgIdFrom,
      defaultSelection,
      onChange: handleChangeOrg,
      sortFunc: sortByTitle,
    }),
    [handleChangeOrg, orgIdFrom, sortByTitle]
  )

  return [selectorProps];
}
